import React, { useEffect, useState } from 'react';
import CarDTO from '../../../dto/CarDTO';
import {
  ECOLOGY_CLASS_TYPE_LIST, OWNERSHIP_TYPE, OWNERSHIP_TYPE_LIST, PROCEDURE_TYPE,
} from '../../../configs';
import { Icons, Row } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import FieldDTOWithCol from '../../../components/fields/Abstract/FieldDTOWithCol';
import TextInputWithLabel from '../../../components/fields/TextInput/TextInputWithLabel';
import DateTimePicker from '../../../components/fields/DatePicker/DateTimePicker';
import Switches from '../../../components/fields/Switches/Switches';
import CustomSelectInput from '../../../components/fields/SelectInput/CustomSelectInput';
import { grzTransliterationTransform } from '../../../utils/utils';

export default function CarFormRegistry(props) {
  const {
    prefix, disabled, control, selectedProcedure, watch, getValues, federal_law_number,
  } = props;
  const dto = new CarDTO({ federal_law_number });
  const attributes = dto.getAttributesByName();

  const [ownership_type, setOwnershipType] = useState(false);
  React.useEffect(() => {
    const subscription = watch(values => {
      const currentType = getValues('ownership_type');
      if (currentType === OWNERSHIP_TYPE.OWNER) {
        setOwnershipType(currentType);
        return;
      }
      setOwnershipType('');
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  useEffect(() => {
    const currentType = getValues('ownership_type');
    if (currentType === OWNERSHIP_TYPE.OWNER) {
      setOwnershipType(currentType);
    }
  }, []);

  return (
    <>
      {selectedProcedure !== PROCEDURE_TYPE.PROCEDURE_1227_8 ? (
        <>
          <Row className="row-cols-3">
            <FieldDTOWithCol
              control={control}
              type="text"
              component={TextInputWithLabel}
              dtoObject={attributes.vehicle_brand}
              variant="material"
              namePrefix={prefix}
              disabled={disabled}
            />
            <FieldDTOWithCol
              control={control}
              type="text"
              component={TextInputWithLabel}
              dtoObject={attributes.vehicle_model}
              variant="material"
              namePrefix={prefix}
              disabled={disabled}
            />
            <FieldDTOWithCol
              control={control}
              type="text"
              component={CustomSelectInput}
              dtoObject={attributes.vehicle_year}
              variant="material"
              options={Array.from({ length: new Date().getFullYear() - 1899 }, (_, i) => ({
                value: new Date().getFullYear() - i,
                name: `${new Date().getFullYear() - i}`,
              }))}
              namePrefix={prefix}
              withLabel
              disabled={disabled}
            />
          </Row>
          <Row className="row-cols-3">
            <FieldDTOWithCol
              control={control}
              type="text"
              dtoObject={attributes.vehicle_color}
              variant="material"
              namePrefix={prefix}
              disabled={disabled}
              component={CustomSelectInput}
              withLabel
              options={[{ value: '', name: ' ' }, { value: 'белый', name: 'Белый' }, { value: 'не белый', name: 'Не Белый' }]}
            />
            <FieldDTOWithCol
              control={control}
              type="text"
              component={TextInputWithLabel}
              dtoObject={attributes.vehicle_lpn}
              transform={grzTransliterationTransform}
              variant="material"
              namePrefix={prefix}
              disabled={disabled}
            />
            <FieldDTOWithCol
              control={control}
              type="text"
              component={TextInputWithLabel}
              dtoObject={attributes.vehicle_vin}
              variant="material"
              namePrefix={prefix}
              disabled={disabled}
              afterContent={<Icons customIcon className="move-icon" width={24} height={24} icon="move-icon" />}
            />
          </Row>
        </>
      ) : null}
      <Row className="row-cols-3">
        <FieldDTOWithCol
          control={control}
          type="text"
          component={TextInputWithLabel}
          dtoObject={attributes.vehicle_registration_number}
          variant="material"
          namePrefix={prefix}
          disabled={disabled}
        />
        <FieldDTOWithCol
          control={control}
          type="text"
          component={DateTimePicker}
          hideTime
          changeFormat="YYYY-MM-DD"
          withLabel
          dtoObject={attributes.vehicle_registration_issue_date}
          variant="material"
          namePrefix={prefix}
          disabled={disabled}
        />
        {selectedProcedure !== PROCEDURE_TYPE.PROCEDURE_1227_8 ? (
          <FieldDTOWithCol
            control={control}
            type="text"
            component={CustomSelectInput}
            dtoObject={attributes.ecology_class}
            variant="material"
            namePrefix={prefix}
            disabled={disabled}
            withLabel
            options={ECOLOGY_CLASS_TYPE_LIST}
          />
        ) : null}
      </Row>
      {selectedProcedure !== PROCEDURE_TYPE.PROCEDURE_1227_8 ? (
        <>
          <Row className="row-cols-1">
            <FieldDTOWithCol
              control={control}
              type="text"
              component={Switches}
              dtoObject={attributes.has_special_lifting_device}
              variant="material"
              disabled={disabled}
              withLabel
            />
          </Row>
          <Row className="row-cols-1">
            <FieldDTOWithCol
              control={control}
              type="text"
              component={TextInputWithLabel}
              dtoObject={attributes.technical_control_address}
              variant="material"
              namePrefix={prefix}
              disabled={disabled}
            />
          </Row>
        </>
      ) : null}
      <Row className="row-cols-2">
        <FieldDTOWithCol
          control={control}
          component={CustomSelectInput}
          dtoObject={attributes.ownership_type}
          variant="material"
          namePrefix={prefix}
          disabled={disabled}
          withLabel
          options={OWNERSHIP_TYPE_LIST}
        />

        <FieldDTOWithCol
          control={control}
          type="text"
          component={TextInputWithLabel}
          variant="material"
          namePrefix={prefix}
          dtoObject={
              ownership_type
                ? {
                  ...attributes.ownership_contract_number,
                  validators: [],
                }
                : attributes.ownership_contract_number
          }
          disabled={disabled}
          withLabel
        />
      </Row>
      <Row className="row-cols-2">
        <FieldDTOWithCol
          control={control}
          type="text"
          component={DateTimePicker}
          hideTime
          changeFormat="YYYY-MM-DD"
          variant="material"
          namePrefix={prefix}
          dtoObject={
              ownership_type
                ? {
                  ...attributes.ownership_contract_effective_date,
                  validators: [],
                }
                : attributes.ownership_contract_effective_date
          }
          disabled={disabled}
          withLabel
        />
        <FieldDTOWithCol
          control={control}
          type="text"
          component={DateTimePicker}
          hideTime
          changeFormat="YYYY-MM-DD"
          variant="material"
          namePrefix={prefix}
          dtoObject={
              ownership_type
                ? {
                  ...attributes.ownership_contract_expiration_date,
                  validators: [],
                }
                : attributes.ownership_contract_expiration_date
          }
          disabled={disabled}
          withLabel
        />
      </Row>
    </>
  );
}
